//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model

import blazern.lexisoup.graphql.model.adapter.TranslateQuery_ResponseAdapter
import blazern.lexisoup.graphql.model.adapter.TranslateQuery_VariablesAdapter
import blazern.lexisoup.graphql.model.selections.TranslateQuerySelections
import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.ExecutableDefinition
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import blazern.lexisoup.graphql.model.type.Query as CompiledQuery

public data class TranslateQuery(
  public val texts: List<String>,
  public val langFromIso3: String,
  public val langToIso3: String,
) : Query<TranslateQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    TranslateQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = ADAPTER

  override fun rootField(): CompiledField = ROOT_FIELD

  @ApolloAdaptableWith(TranslateQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val translate: Translate,
  ) : Query.Data

  public data class Translate(
    public val translations: List<String>,
    public val source: String,
  )

  public companion object : ExecutableDefinition<Data> {
    override val ADAPTER: Adapter<Data> = TranslateQuery_ResponseAdapter.Data.obj()

    override val ROOT_FIELD: CompiledField = CompiledField.Builder(
          name = "data",
          type = CompiledQuery.type
        )
        .selections(selections = TranslateQuerySelections.__root)
        .build()

    public const val OPERATION_ID: String =
        "0473fc6b874cca14819c1d23e6600d063e9e2a99b2aefa3539e93528c98b2bc1"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query TranslateQuery($texts: [String!]!, $langFromIso3: String!, $langToIso3: String!) {
     *   translate(texts: $texts, langFromIso3: $langFromIso3, langToIso3: $langToIso3) {
     *     translations
     *     source
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query TranslateQuery(${'$'}texts: [String!]!, ${'$'}langFromIso3: String!, ${'$'}langToIso3: String!) { translate(texts: ${'$'}texts, langFromIso3: ${'$'}langFromIso3, langToIso3: ${'$'}langToIso3) { translations source } }"

    public const val OPERATION_NAME: String = "TranslateQuery"
  }
}
